export enum CheckoutOrigin {
    AUSTRALIA = 'australia',
    CA = 'ca',
    DOMESTIC = 'domestic',
    INTERNATIONAL = 'international',
    NZ = 'nz',
    UAE = 'uae',
    UK = 'uk'
};

export enum Region {
    AU = 'AU',
    AE = 'AE',
    CA = 'CA',
    EU = 'EU',
    NZ = 'NZ',
    UK = 'UK',
    US = 'US',
};

export const CheckoutOriginRegions: Record<CheckoutOrigin, Region> = {
    'australia': Region.AU,
    'ca': Region.CA,
    'domestic': Region.US,
    'international': Region.EU,
    'nz': Region.NZ,
    'uae': Region.AE,
    'uk': Region.UK,
};

export enum Language {
    DE = 'de',
    EN = 'en',
    FR = 'fr',
};

export enum CurrencyCode {
    AED = 'aed',
    AUD = 'aud',
    CAD = 'cad',
    EUR = 'eur',
    GBP = 'gbp',
    NZD = 'nzd',
    USD = 'usd',
};
